import React, {useEffect} from "react";
import {
    Drawer,
} from "antd";
import {FormUserProfileEdit} from "./formUserProfileEdit";
import {FormUserProfileFlag} from "./formUserProfileFlag";

export const FormEditProfile = ({
    isModalOpen,
    showFormUserProfile,
    typeForm = "",
    profileInfo,handleUpdateProfile,
    genderIdentityCatalog = []
}) => {

    useEffect(() => {
        if (isModalOpen) {
            document.body.style.setProperty("overflow", "hidden", "important");
        } else {
            document.body.style.setProperty("overflow", "auto", "important");
        }
        return () => {
            document.body.style.setProperty("overflow", "auto", "important");
        };
    }, [isModalOpen]);

    return (
        <Drawer
            title=""
            onClose={() => showFormUserProfile(false)}
            open={isModalOpen}
            maskClosable
            width={600}
            className="fixed"
        >
            {typeForm === "user" && (
                <FormUserProfileEdit
                    showFormUserProfile={showFormUserProfile}
                    isModalOpen={isModalOpen}
                    profileInfo={profileInfo}
                    handleUpdateProfile={handleUpdateProfile}
                />
            )}
            {typeForm === "myFlag" && (
                <FormUserProfileFlag
                    showFormUserProfile={showFormUserProfile}
                    isModalOpen={isModalOpen}
                    genderIdentityCatalog={genderIdentityCatalog}
                    profileInfo={profileInfo}
                    handleUpdateProfile={handleUpdateProfile}
                />
            )}
        </Drawer>
    );
};
